module.exports = __webpack_public_path__ + "static/media/sliderq.caf535d2.jpg";